import React from 'react';

import { find } from 'lodash';
import { Controller, useForm } from 'react-hook-form';

import classes from 'components/Dashboards/Project/Components/CustomDashboard/ModalManager/modalManager.module.scss';
import {
    IDashBoardModal,
    IUpdateDashboardModalProps,
} from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.type';
import { Button } from 'components/DesignSystem/Button';
import { Modal } from 'components/DesignSystem/Modal';
import { TextInput } from 'components/DesignSystem/TextInput/TextInput';
import { CustomizedFormErrorMessage, CustomizedModalBase } from 'components/common';

/**
 * Modal for creating and renaming dashboard .
 * @param {boolean}  showModal - determines if this modal is visible.
 * @param {() => void}  onHideModal - hide  modal function.
 * @param {({dashboard: string}) => void}  handleSave - form submit function.
 * @param {IDashboard[]} dashboards - list of all pinboards (get from API like JSON object).
 * @param { dashboard: IDashboard}  value - specific dashboard
 * @param isLoading
 * @returns  Modal
 * */
export const UpdateDashboardModal = ({
    showModal,
    onHideModal,
    handleSave,
    dashboards,
    value,
    isLoading,
}: IUpdateDashboardModalProps) => {
    const name = value?.dashboard?.name;
    const {
        handleSubmit,
        setValue,
        control,
        formState: { errors },
    } = useForm<IDashBoardModal>();
    const onSubmit = (data) => {
        handleSave(data);
    };
    const title = value ? 'Rename Pinboard' : 'Create Pinboard';

    return (
        <Modal
            open={showModal}
            onClose={onHideModal}
            title={title}
            actions={
                <>
                    <Button size={'large'} variant={'secondary'} onClick={onHideModal}>
                        Cancel
                    </Button>
                    <Button
                        size={'large'}
                        variant={'primary'}
                        type={'submit'}
                        isLoading={isLoading}
                        disabled={isLoading}
                        onClick={handleSubmit(onSubmit)}
                    >
                        {title}
                    </Button>
                </>
            }
        >
            <div className={classes.modalContainer}>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className={classes.inputTitle}>Pinboard Name *</div>

                    <div className={classes.inputWrapper}>
                        <Controller
                            render={({ field }) => (
                                <TextInput
                                    {...field}
                                    placeholder={'Enter Name'}
                                    maxLength={100}
                                    onClear={() => {
                                        setValue('dashboard', '');
                                    }}
                                    id={'dashboard'}
                                />
                            )}
                            name={`dashboard`}
                            control={control}
                            rules={{
                                required: 'Name is Required',
                                validate: (value) =>
                                    find(dashboards, {
                                        name: value,
                                    }) === undefined || 'Pinboard already exists',
                            }}
                            defaultValue={name || 'Custom Pinboard'}
                        />
                    </div>

                    {errors.dashboard && <CustomizedFormErrorMessage text={errors.dashboard.message} />}
                </form>
            </div>
        </Modal>
    );
};
